import { Link } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function UnauthorizedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="text-center max-w-md">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10 mx-auto mb-6">
          <ShieldAlert className="h-10 w-10 text-destructive" />
        </div>
        
        <h1 className="text-3xl font-bold text-foreground mb-2">
          Acceso Denegado
        </h1>
        
        <p className="text-muted-foreground mb-8">
          No tienes permisos para acceder a esta página. Contacta al administrador si crees que esto es un error.
        </p>
        
        <Button asChild variant="gradient">
          <Link to="/dashboard">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver al Dashboard
          </Link>
        </Button>
      </div>
    </div>
  );
}
